import { BiBookOpen, BiCookie, BiData, BiFile, BiHome, BiInfoCircle } from 'react-icons/bi';
import { FiCompass } from 'react-icons/fi';
import { GrResources } from 'react-icons/gr';
import { HiOutlineDocumentReport, HiSparkles } from 'react-icons/hi';
import { IoDocumentLockOutline, IoDocumentTextOutline } from 'react-icons/io5';

import { VersionInfoParams } from 'hooks/useVersionInfo/types';

import { NavLink } from './types';

export const topLinks = ({ ver, system_model }: VersionInfoParams): NavLink[] => [
  {
    label: 'Home',
    path: `/${ver}/${system_model}`,
    icon: BiHome,
    exactMatch: true,
  },
  {
    label: 'Datasets',
    path: `/${ver}/${system_model}/search`,
    extraMatchingPaths: [`/${ver}/${system_model}/dataset`, `/${ver}/${system_model}/compare`],
    icon: BiData,
  },
  {
    label: 'Resources',
    icon: GrResources,
    chevronTourTarget: 'resources-chevron',
    subItems: [
      {
        label: 'Files',
        path: `/${ver}/${system_model}/files`,
        icon: BiFile,
      },
      {
        label: 'Reports',
        path: `/${ver}/${system_model}/reports`,
        icon: HiOutlineDocumentReport,
      },
      {
        label: 'Product Tour',
        path: '#product-tour',
        icon: FiCompass,
      },
      {
        label: 'Knowledge Base',
        path: 'https://support.ecoinvent.org/',
        isExternal: true,
        icon: BiBookOpen,
      },
    ],
  },
  {
    label: 'Legal & Privacy',
    icon: BiInfoCircle,
    subItems: [
      {
        label: 'Privacy Policy',
        path: 'https://ecoinvent.org/gdpr-eula#privacy-policy',
        isExternal: true,
        icon: IoDocumentLockOutline,
      },
      {
        label: 'EULA',
        path: 'https://ecoinvent.org/gdpr-eula#eula',
        isExternal: true,
        icon: IoDocumentTextOutline,
      },
      {
        label: 'Cookie Preferences',
        path: '#cookie-preferences',
        icon: BiCookie,
      },
    ],
  },
  {
    label: "What's new",
    path: `/${ver}/${system_model}/whats-new`,
    icon: HiSparkles,
  },
];
